import React, { Component, Fragment } from 'react';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import Header from "./Header";
import Footer from './Footer';
import { NavLink } from 'react-router-dom';
import { authActions, notificationActions } from '../../common/redux/actions';
import { Role } from '../../helpers';
import { ClickAwayListener } from '@material-ui/core';

class DashboardLayout extends Component {

    constructor(props) {
        //this.userData = props.authentication;
        super(props);
        this.state = {
            mobileClass: false,
            toggleClass: false,
            status:''
        };
    }

    onLogout = () => {
        const { dispatch } = this.props;
        dispatch(authActions.logout());
    };

    toggleMenu = () => {
        const currentState = this.state.toggleClass;
        this.setState({ toggleClass: !currentState });
        localStorage.setItem('togglemenu', currentState === true ? false : true);
    }

    ReadCount = () => {
        const { dispatch, authentication } = this.props;
        dispatch(notificationActions.removeCount(authentication.authentication));
    }

    clickAway = () => {
        //const currentState = this.state.mobileClass;
        this.setState({ mobileClass: false });
    }

    handleMobile = () => {
        const currentState = this.state.mobileClass;
        this.setState({ mobileClass: !currentState });
    }

    render() {
        const { children, className, authentication, activeClass } = this.props;
        const { user } = authentication.authentication;
        const toggleClass = localStorage.getItem('togglemenu');
        const count = user.userProfile && user.userProfile.notifications;
        let status = user.is_verified !== 2 ? this.state.status =  "unauthorized" : '';

        return (
            <Fragment>
                <Header />
                <main className={`all-content dashboard-layout ${(className && className) ? className : ''} ${(toggleClass === 'true') ? 'toggle-layout' : ''} ${(this.state.mobileClass) ? 'mobile-active' : 'mobile'}`}>

                    <ClickAwayListener onClickAway={this.clickAway}>
                        <aside id="left-side">
                            <button className="navbar-toggler collapsed" onClick={this.handleMobile}><span className="fas fa-bars"></span></button>
                            <div className="side-inner">
                                <div className="profile">
                                    <span className="img">
                                        <img src={(user && user.avatar) ? user.avatar : '/images/dummy-profile.png'} alt="" className=" border rounded-circle mr-2" width="40" height="40" />
                                    </span>
                                    <span className="username">{user && user.name}</span>
                                    <button className="btn btn-link btn-toggle" onClick={this.toggleMenu}><i className="fas fa-angle-right"></i></button>
                                </div>
                                <ul className="aside-menu">
                                    {(user && user.role === Role.User) && <>
                                        <li>
                                            <NavLink to="/user/dashboard">
                                                <span className="img" title="Dashboard"><img src="/images/svg/dashboard.svg" alt="Dashboard" /></span>
                                                <span className="name">Dashboard</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/user/bookings" className={(activeClass && activeClass === 'UserBooking') ? 'active' : ''}>
                                                <span className="img" title="My Bookings"><img src="/images/svg/booking.svg" alt="Dashboard" /></span>
                                                <span className="name">My Bookings</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/user/favorites">
                                                <span className="img" title="Favorite Tutors"><img src="/images/svg/Profile2.png" alt="Dashboard" /></span>
                                                <span className="name">Favorite Tutors</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/user/transaction">
                                                <span className="img" title="Transaction History"><img src="/images/svg/payment-history.svg" alt="Transaction" /></span>
                                                <span className="name">Transaction History</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/user/update-profile" className={(activeClass && activeClass === 'UserSetting') ? 'active' : ''}>
                                                <span className="img" title="Account Setting"><img src="/images/svg/Setting.svg" alt="Setting" /></span>
                                                <span className="name">Account Setting</span>
                                            </NavLink>
                                        </li>
                                    </>}

                                    {(user && user.role === Role.Tutor) && <>
                                        <li>
                                            <NavLink to="/tutor/dashboard">
                                                <span className="img" title="Dashboard"><img src="/images/svg/dashboard.svg" alt="Dashboard" /></span>
                                                <span className="name">Dashboard</span>
                                            </NavLink>
                                        </li>
                                        <li className={status}>
                                            <NavLink to="/tutor/profile" className={(activeClass && activeClass === 'TutorProfile') ? 'active' : ''} onClick={() => localStorage.setItem('activeStep', 0)}>
                                                <span className="img" title="Profile"><img src="/images/svg/Profile2.png" alt="Profile" /></span>
                                                <span className="name">Profile</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/tutor/membership">
                                                <span className="img" title="Membership"><img src="/images/svg/Membership.svg" alt="Dashboard" /></span>
                                                <span className="name">Membership</span>
                                            </NavLink>
                                        </li>
                                        
                                        <li className={status}>
                                            <NavLink  to="/tutor/bookings" className={(activeClass && activeClass === 'UserBooking') ? 'active' : ''}>
                                                <span className="img" title="My bookings"><img src="/images/svg/booking.svg" alt="Dashboard" /></span>
                                                <span className="name">My bookings</span>
                                            </NavLink>
                                        </li>

                                        <li className={status}>
                                            <NavLink to="/tutor/transaction">
                                                <span className="img" title="Transaction History"><img src="/images/svg/payment-history.svg" alt="Transaction" /></span>
                                                <span className="name">Transaction History</span>
                                            </NavLink>
                                        </li>

                                        <li className={status}>
                                            <NavLink to="/notifications" onClick={() => this.ReadCount()}>
                                                <span className="img" title="Notifications"><img src="/images/svg/Bell.svg" alt="Notifications" />
                                                    {(count !== 0) && <span id="count">{count}</span>}
                                                </span>
                                                <span className="name">Notifications</span>
                                            </NavLink>
                                        </li>

                                        <li className={status}>
                                            <NavLink to="/tutor/change-password" className={(activeClass && activeClass === 'UserSetting') ? 'active' : ''}>
                                                <span className="img" title="Account Setting"><img src="/images/svg/Setting.svg" alt="Setting" /></span>
                                                <span className="name">Account Setting</span>
                                            </NavLink>
                                        </li>
                                    </>}
                                    
                                    <li>
                                        <NavLink to="/home" onClick={this.onLogout}>
                                            <span className="img" title="Logout"><img src="/images/svg/logout.svg" alt="Logout" /></span>
                                            <span className="name">Logout</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </aside>
                    </ClickAwayListener>
                    <div id="right-side">
                        {children}
                    </div>
                </main>
                <Footer />
            </Fragment>
        );
    }
}
const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    authenticationSelector,
    (authentication) => ({
        authentication
    })
);

export default connect(mapStateToProps)(DashboardLayout);
